import axios from "axios";
axios.defaults.baseURL = "https://yartirush.herokuapp.com/api";
export const Send = async (method, url, data) => {
  let res = await axios({
    method,
    url,
    data,
  });
  return res.data;
};
